
























import Vue from 'vue';
import { mapGetters } from 'vuex';

import ReportWrapper from '@/components/Presenter/SessionReport/ReportWrapper.vue';
import WordcloudResult from '@/components/Presenter/SessionReport/WordcloudResult.vue';

export default Vue.extend({
  components: {
    ReportWrapper,
    WordcloudResult,
  },
  data() {
    return {
      now: new Date(),
      selectedTabItem: 0,
      qrCodeURL: '',
      showEmbedModal: false,
    };
  },
  async mounted() {
    const presenterSessionId = this.$route.params.presenterSessionId;
    await this.$store.dispatch(
      'presenter/fetchPresenterSession',
      presenterSessionId
    );
    await this.$store.dispatch('viewer/fetchSessionTheme', {
      sessionUserGroup: this.currentSession.userGroup,
    });
  },
  computed: {
    ...mapGetters({
      currentSession: 'presenter/getCurrentSession',
      sessionViewers: 'viewer/getSessionViewers',
      wordclouds: 'presenter/getSessionWordclouds',
    }),
  },
});
